import { Inject, Injectable } from '@angular/core';
import { SentryService } from '@rd-lib/sentry/sentry.service';
import { PaymentGatewayService } from '@rd/core/services/payment-gateway/payment-gateway.service';
import { ENV, STRIPE_API_KEY } from '@rd/core/tokens/rd-lib.token';
import { StripeElementsOptions, StripeElementStyle } from '@stripe/stripe-js';
import { AnzEnvironmentType } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class AnzPaymentGatewayService extends PaymentGatewayService {
  isEnable = true;

  // this is the UI customized config for stripe form
  // stripe only allow customized stripe element via config instead of CSS class
  elementStyles: StripeElementStyle = {
    base: {
      color: '#32325D',
      fontWeight: '400',
      fontFamily: 'MyriadPro, Arial, Helvetica, sans-serif',
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      lineHeight: '24px',

      '::placeholder': {
        color: '#CFD7DF',
      },
      ':-webkit-autofill': {
        color: '#e39f48',
      },
    },
    invalid: {
      color: '#E25950',

      '::placeholder': {
        color: '#FFCCA5',
      },
    },
  };

  stripeElementsCofig: StripeElementsOptions = {
    fonts: [
      {
        family: 'MyriadPro',
        src: 'url(https://d2xr67b5foriew.cloudfront.net/fonts/myriadpro/MyriadPro-Regular.woff2)',
      },
    ],
  };

  constructor(
    protected sentryService: SentryService,
    @Inject(STRIPE_API_KEY) protected stripeApiKey: string,
    @Inject(ENV) private env: AnzEnvironmentType,
  ) {
    super(sentryService, stripeApiKey);
  }
}
